import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: (startDate, filters) => ({
        operable: filters.operable,
        date:     Math.floor(startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'CMDBBackupLast13m',
        endpoint:           endpoints.cmdb.backupLast13m,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => [
            {
                name: 'withBackup',
                data: response.with_backup.map(i => ({y: i.amount, x: i.period * TIMESTAMP_MULTIPLY}))
            },
            {
                name: 'withoutBackup',
                data: response.without_backup.map(i => ({y: i.amount, x: i.period * TIMESTAMP_MULTIPLY}))
            }
        ]
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/CMDBBackupLast13m.js